import {
  RequestStatus,
  GET_ACCESS_RULES,
  MANAGE_ACCESS_RULES,
} from 'constants';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import api from '@control-front-end/common/sagas/api';

/**
 * Редактирование настроек доступа
 */
export function* manageAccessRules({ payload, callback }) {
  const { body, objType, objId, recursive } = payload;
  const config = yield select((state) => state.config);
  if (!body.length) return;
  const { result, data } = yield call(api, {
    method: 'post',
    url: `/access_rules/${objType}/${objId}`,
    queryParams: { recursive },
    body,
  });
  if (result !== RequestStatus.SUCCESS) return;
  for (const a of data.data) {
    a.avatar = config.avatarPath.replace('{userId}', a.userId);
  }
  yield put({ type: MANAGE_ACCESS_RULES.SUCCESS, payload: data.data });
  if (callback) callback(data.data);
}

/**
 * Получение настроек доступа
 */
function* getAccessRules({ payload, callback }) {
  const { objType, objId } = payload;
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/access_rules/${objType}/${objId}`,
  });
  if (result !== RequestStatus.SUCCESS) return;
  const config = yield select((state) => state.config);
  for (const a of data.data) {
    a.avatar = config.avatarPath.replace('{userId}', a.userId);
  }
  yield put({ type: GET_ACCESS_RULES.SUCCESS, payload: data.data });
  if (callback) callback(data.data);
}

function* accessRules() {
  yield takeLatest(MANAGE_ACCESS_RULES.REQUEST, manageAccessRules);
  yield takeLatest(GET_ACCESS_RULES.REQUEST, getAccessRules);
}

export default accessRules;
